import { sprig } from '@sprig-technologies/sprig-browser';
import { sha256 } from 'js-sha256';

var FEEDBACK_COLLECTION_ID_NOT_SET = 'Feedback Collection Id is not set';
var FEEDBACK_COLLECTION_INITIALIZED = 'Feedback Collection SDK initialized';

// TODO:
// 4. Update all readmes with appropriate documentation
var FeedbackCollection = /*#__PURE__*/function () {
  function FeedbackCollection() {}
  var _proto = FeedbackCollection.prototype;
  _proto.initialize = function initialize(collectionId) {
    if (!collectionId) {
      console.warn(FEEDBACK_COLLECTION_ID_NOT_SET);
      return;
    }
    var configuration = {
      environmentId: collectionId
    };
    this.feedbackSdk = sprig.configure(configuration);
    console.info(FEEDBACK_COLLECTION_INITIALIZED);
  }
  /**
   * @description Sends a unique id for the current user and helps to keep our MTAs low
   */;
  _proto.setUserId = function setUserId(userId) {
    var hashedId = sha256("" + userId);
    if (this.feedbackSdk) {
      this.feedbackSdk.setUserId(hashedId);
    }
  }
  /**
   * @description Logs out the current user from Sprig and can only be used if the sendUserId method is also being used
   */;
  _proto.logout = function logout() {
    if (this.feedbackSdk) {
      this.feedbackSdk.logoutUser();
    }
  }
  /**
   * @description Sends a custom event that can be used to trigger an event in the SPRIG dashboard, only use this is absolutely necessary
   */;
  _proto.sendTrackingEvent = function sendTrackingEvent(event) {
    if (this.feedbackSdk) {
      this.feedbackSdk.identifyAndTrack(event);
    }
  };
  return FeedbackCollection;
}();
var FeedbackCollectionSingleton = /*#__PURE__*/new FeedbackCollection();

export default FeedbackCollectionSingleton;
export { FeedbackCollection };
//# sourceMappingURL=feedback-collection.esm.js.map
